import React from 'react';

import FieldValues from 'components/FieldValues';
import SummaryBlocksListItem from './components/SummaryBlocksListItem';

export default function FertilizerEventSummaryBlocks(): React.ReactElement {
    return (
        <FieldValues
            fieldNames={['fertilizerEntityIds', 'entityId']}
        >
            {({
                fertilizerEntityIds,
                entityId
            }): React.ReactElement => (
                <SummaryBlocksListItem
                    entityIds={fertilizerEntityIds}
                    entityId={entityId}
                />
            )}
        </FieldValues>
    );
}
